import { render, staticRenderFns } from "./TraxTrainingCompetencyDomainsCrudTable.vue?vue&type=template&id=bc69418e"
import script from "./TraxTrainingCompetencyDomainsCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyDomainsCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports